module.exports = __webpack_public_path__ + "img/footer_wx_code.3796df9.jpg";